import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const MerchantAccessRight = {
  VIEW_MERCHANTS: ({ menuDisplayLevel }) => menuDisplayLevel <= 1,
  EDIT_MERCHANTS: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  NUMBER_PROVISIONING: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  DEACTIVATE: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  SUSPEND_MERCHANT: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  RESUME_MERCHANT: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  VERIFY: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  VIEW_EDIT_COOLDOWN_INTERVAL: ({ menuDisplayLevel }) => menuDisplayLevel <= 1,
  VIEW_EDIT_DISPATCH_EXTENDED: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  VIEW_EDIT_CARRIER_GO_LIVE: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  CONFIGURE_MONTHLY_VOLUMES: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
  ENABLE_MMS: ({ menuDisplayLevel }) => menuDisplayLevel === 0,
} satisfies Record<string, AuthenticationAccessRight>;
